(function () {
    'use strict';
    $(document).ready(function () {
        decorSize();

        $( window ).resize(function() {
            decorSize();
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                return position;
            },
        });

        function decorSize() {
            $('.decor').each(function (){
                let text = $(this).parent().find('.quotation-wrapper');

                if (text.length) {
                    let textHeight = text.height();
                    $(this).css('height', textHeight + 200);
                }
            });
        }

        function updateTableSize() {
            $('.table-container').each(function () {
                if ($(this).parent().hasClass('panel-body')) return;
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

        $('.swiper.gallery-swiper').each(function (){
            let gallerySwiper = new Swiper($(this)[0], {
                slidesPerView: 1,
                spaceBetween: 20,
                breakpoints: {
                    // when window width is >= 575px
                    575: {
                        slidesPerView: 2,
                        spaceBetween: 25
                    },
                    // when window width is >= 992px
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 35
                    }
                },
                navigation: {
                    nextEl: '.gallery-swiper .swiper-button-next',
                    prevEl: '.gallery-swiper .swiper-button-prev',
                },
            });
        });

        $('.swiper.image-slider-swiper').each(function (){
            let imageSliderSwiper = new Swiper($(this)[0], {
                spaceBetween: 100,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                navigation: {
                    nextEl: '.image-slider-main .swiper-button-next',
                    prevEl: '.image-slider-main .swiper-button-prev',
                },
            });
        });

    });
}(jQuery));
